import React from "react";

import { Badge, BadgeProps } from "@mui/material";

export const IgBadge = (props: BadgeProps) => {
  const { children, badgeContent, color, ...rest } = props;
  return (
    <Badge color={color} badgeContent={badgeContent} {...rest}>
      {children}
    </Badge>
  );
};
